var map = {
	"./CatalogCarousel/CatalogCarousel.vue": [
		1156,
		167
	],
	"./CatalogCarousel/CatalogItem.vue": [
		1149,
		245
	],
	"./MarketingCards.vue": [
		324
	],
	"./ProductCarousel/CarouselProductItem.vue": [
		1150,
		246
	],
	"./ProductCarousel/ProductCarousel.vue": [
		1157,
		5,
		110
	],
	"./ReorderHighlight/ReorderHighlight.vue": [
		1158,
		171
	],
	"./VoucherCarousel/VoucherCardItem.vue": [
		405
	],
	"./VoucherCarousel/VoucherCarousel.vue": [
		401
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1126;
module.exports = webpackAsyncContext;